module.exports = __webpack_public_path__ + "img/airtime.98d853c1.png";